<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-[1000] overflow-y-auto">
    <div class="bg-white rounded-2xl shadow-[0_24px_60px_rgba(40,56,66,0.30)] w-full max-w-[700px] max-h-[85vh] flex flex-col overflow-hidden">

        <div class="flex items-center justify-between px-5 py-3 bg-gradient-to-b from-[#f8fbff] to-white border-b border-[#e8edf3] rounded-t-2xl shrink-0">
            <h2 class="text-base font-bold text-corporate-3 m-0">Buscar cliente</h2>
            <a (click)='closeEvent($event)' class="flex items-center justify-center w-8 h-8 rounded-full text-[#5a6b7a] bg-transparent border-none cursor-pointer transition-all hover:bg-hover-2 hover:text-corporate hover:rotate-90">
                <lucide-icon name="x" [size]="20"></lucide-icon>
            </a>
        </div>

        <div class="flex-1 overflow-y-auto px-5 py-4">
            <div class="flex flex-wrap items-end gap-3">
                <div class="flex flex-col flex-1 min-w-[140px]">
                    <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Cliente</label>
                    <input class="w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate" type="text" [(ngModel)]="nameCustomer" name="search" autocomplete="off" placeholder="Buscar por nombre" (keyup.enter)="onKey(searchText)">
                </div>
                <div class="flex flex-col flex-1 min-w-[140px]">
                    <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Matrícula</label>
                    <input class="w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate" type="text" [(ngModel)]="registration" name="search" autocomplete="off" placeholder="Buscar por matrícula" (keyup.enter)="onKey(searchText)">
                </div>
                <div class="flex flex-col">
                    <label class="text-[12px] font-medium text-corporate-3 mb-1 block invisible">.</label>
                    <div class="flex items-center gap-2">
                    <button class="inline-flex items-center justify-center bg-corporate text-white rounded-lg px-3 h-[32px] text-[13px] font-semibold cursor-pointer border-none transition-all hover:brightness-110" (click)="searchCustomer($event)" type="submit">Buscar</button>
                    <a class="flex items-center justify-center w-8 h-8 rounded-lg text-[#5a6b7a] border border-[#d4dde6] bg-transparent cursor-pointer transition-all hover:bg-hover-2 hover:border-corporate hover:text-corporate" *ngIf="nameCustomer || registration" (click)="clearCustomers($event)">
                            <lucide-icon name="x" [size]="14"></lucide-icon>
                        </a>
                    </div>
                </div>
            </div>

            <div class="mt-4 border-t border-[#e8edf3] pt-3">
                <div *ngIf="loading" class="flex justify-center items-center py-8">
                    <mat-spinner [diameter]="25"></mat-spinner>
                </div>
                <div *ngIf="customers.length==0 && !loading && !error && customersRegistrations.length==0" class="flex justify-center py-8 text-[13px] text-[#8a94a0]">
                    <p>{{msg}}</p>
                </div>

                <div *ngIf="customersRegistrations.length>0" class="flex flex-col gap-1">
                    <div *ngFor="let item of customersRegistrations, let i=index"
                         class="flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-colors"
                         [class.bg-corporate]="selectedDiv === i"
                         [class.text-white]="selectedDiv === i"
                         [class.text-corporate-3]="selectedDiv !== i"
                         [class.hover:bg-hover-2]="selectedDiv !== i"
                         (click)="highlightDiv(i)">
                        <div class="flex flex-wrap items-center gap-4 flex-1">
                            <span class="text-[13px] font-medium">{{item.NOMCLTE}}</span>
                            <span class="text-[13px] opacity-70">{{item.TELEFONO}}</span>
                            <span class="text-[13px] opacity-70">{{item.REGISTRATION}}</span>
                        </div>
                        <a *ngIf="selectedDiv === i" class="flex items-center gap-1 cursor-pointer text-white" (click)="selectCustomer($event,item)">
                            <lucide-icon name="check" [size]="20"></lucide-icon>
                            <span class="text-[13px]">Agregar</span>
                        </a>
                    </div>
                </div>

                <div *ngIf="error" class="flex justify-center py-8 text-error text-[13px]">
                    <p>{{msg}}</p>
                </div>
            </div>
        </div>
    </div>
</div>